import { Stack, Typography, useTheme } from "@mui/material";
import { ReactElement, ReactNode } from "react";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export interface ContentValue {
    value?: string | ReactElement;
    endAdornment?: ReactElement;
}

export interface LabelContentProps {
    label: string;
    content: ReactNode | ContentValue;
}

/**
 * SenecLabelContent is a component that displays a label and content in a stack. The content can be a string or a ReactNode.
 */
export const SenecLabelContent = ({ label, content }: LabelContentProps) => {
    const theme: SenecFPPTheme = useTheme();

    return (
        <Stack key={"tile-row-" + label} data-testid={"tile-row"} spacing={0.25}>
            <Typography variant={"s1"} color={theme.palette.neutralGray70.main}>
                {label}
            </Typography>
            <Typography variant={"s1Medium"} sx={{ wordWrap: "break-word" }}>
                {content as ReactNode}
            </Typography>
        </Stack>
    );
};
